import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'

import Container from 'components/Container'
import Row from 'components/Row'
import Col from 'components/Col'
import TwoStepMultiSelectDropdown from 'components/2StepMultiSelectionDropdown'
import TwoStepMultiSelectLabel from 'components/2StepMultiSelectionDropdown/components/Label'
import { SiteContext } from 'providers/site'
import { requestUpdateSite } from 'api/site'
import Threats from './components/threats'
import ThreatsHeader from './components/threatsHeader'
import { SITE_STATUS_DRAFT_ID } from 'constants/siteStatuses'
import ScrollToTop from 'components/ScrollToTop'

const conservationActions = [
  { value: 1, label: '1.1 Site/area protection' },
  { value: 2, label: '1.2 Resource & habitat protection' },
  { value: 3, label: '2.1 Site/area management' },
  { value: 4, label: '2.2 Invasive/problematic species control' },
  { value: 5, label: '2.3 Habitat & natural process restoration' },
  { value: 6, label: '3.1 Species management' },
  { value: 7, label: '3.2 Species recovery' },
  { value: 8, label: '3.3 Species re-introduction' },
  { value: 9, label: '3.4 Ex-situ conservation' },
  { value: 10, label: '4.1 Formal education' },
  { value: 11, label: '4.2 Training' },
  { value: 12, label: '4.3 Awareness & communications' },
  { value: 13, label: '5.1 Legislation' },
  { value: 14, label: '5.2 Policies and regulations' },
  { value: 15, label: '5.3 Private sector standards & codes' },
  { value: 16, label: '5.4 Compliance and enforcement' },
  { value: 17, label: '6.1 Linked enterprises & livelihood alternatives' },
  { value: 18, label: '6.2 Substitution' },
  { value: 19, label: '6.3 Market forces' },
  { value: 20, label: '6.4 Conservation payments' },
  { value: 21, label: '6.5 Non-monetary values' }
]

const SiteProposalMonitoringPage = () => {
  const { site, isEditable } = useContext(SiteContext)
  const params = useParams()

  const [ongoingConservationActions, setOngoingConservationActions] = useState(site.ongoingConservationActions || [])
  const [conservationActionsNeeded, setConservationActionsNeeded] = useState(site.conservationActionsNeeded || [])

  if (!site.id) return null

  const disabled = site.SiteStatusId !== SITE_STATUS_DRAFT_ID || (!isEditable && site.SiteStatusId === SITE_STATUS_DRAFT_ID)

  const updateOngoingConservationActions = (newIds) => {
    setOngoingConservationActions(newIds)
    requestUpdateSite(params.id, params.siteHistoryId, { ongoingConservationActions: newIds })
  }

  const updateConservationActionsNeeded = (newIds) => {
    setConservationActionsNeeded(newIds)
    requestUpdateSite(params.id, params.siteHistoryId, { conservationActionsNeeded: newIds })
  }

  return (
    <div>
      <ThreatsHeader marginBottom='64px' title='action' subTitle='whatActionsAreAssessingForThisSite' subTitleHint='actionsHint' firstTitle={true} />
      <Container>
        <Row>
          <Col md={8} mdOffset={2}>
            <TwoStepMultiSelectDropdown
              marginBottom="16px"
              label={TwoStepMultiSelectLabel({ heroText: 'A', labelText: 'ongoingConservationActionsAtSite', active: ongoingConservationActions})}
              secondStepOptions={conservationActions}
              value={ongoingConservationActions}
              saveChanges={updateOngoingConservationActions}
              disabled={disabled}
            />
            <TwoStepMultiSelectDropdown
              marginBottom="16px"
              label={TwoStepMultiSelectLabel({ heroText: 'B', labelText: 'conservationActionsNeeded', active: conservationActionsNeeded })}
              secondStepOptions={conservationActions}
              value={conservationActionsNeeded}
              saveChanges={updateConservationActionsNeeded}
              disabled={disabled}
            />
          </Col>
        </Row>
      </Container>
      <Container width='100%' padding='0px'>
        <Row>
          <Col md={12}>
            <Threats site={site} disabled={disabled}/>
          </Col>
        </Row>
        <ScrollToTop bottom="104px" />
      </Container>
    </div>
  )
}

export default SiteProposalMonitoringPage
